import { render, staticRenderFns } from "./modalAddressItems.vue?vue&type=template&id=2628459f&scoped=true"
import script from "./modalAddressItems.vue?vue&type=script&lang=js"
export * from "./modalAddressItems.vue?vue&type=script&lang=js"
import style0 from "./modalAddressItems.vue?vue&type=style&index=0&id=2628459f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2628459f",
  null
  
)

export default component.exports